import Home from "./Home"
import Clients from "./Clients"
import Database from "./Database"

export { Clients, Database }
export default Home
